import React from 'react';
import { string, number, any, arrayOf } from 'prop-types';

import { activeDotAxisWidth } from '../../../../constants/sizes';

import CustomLabelText from './CustomLabelText';

const marginTop = 15;

const chooseColor = (years, year, firstColor, secondColor, thirdColor) => {
  if (years[0].toString() === year.toString()) return firstColor;
  if (years[1].toString() === year.toString()) return secondColor;
  return thirdColor;
};

const CustomXAxisLabel = ({
  x,
  y,
  activeValue,
  activeFirstColor,
  activeSecondColor,
  activeThirdColor,
  inactiveColor,
  payload,
  years
}) =>
  activeValue && payload.value.slice(-2) === activeValue ? (
    <svg>
      <circle
        cx={x}
        cy={y + marginTop}
        r={activeDotAxisWidth}
        style={{
          stroke: chooseColor(
            years,
            payload.value.slice(0, 4),
            activeFirstColor,
            activeSecondColor,
            activeThirdColor
          ),
          strokeOpacity: '.4',
          strokeWidth: activeDotAxisWidth,
          fill: chooseColor(
            years,
            payload.value.slice(0, 4),
            activeFirstColor,
            activeSecondColor,
            activeThirdColor
          )
        }}
      />
      <CustomLabelText x={x} y={y + marginTop} text={activeValue} color="white" bold />
    </svg>
  ) : (
    <svg>
      <CustomLabelText x={x} y={y + marginTop} text={payload.value.slice(-2)} color={inactiveColor} />
    </svg>
  );

CustomXAxisLabel.propTypes = {
  x: number,
  y: number,
  activeValue: string,
  activeFirstColor: string.isRequired,
  activeSecondColor: string.isRequired,
  activeThirdColor: string.isRequired,
  inactiveColor: string.isRequired,
  years: arrayOf(number).isRequired,
  payload: any // eslint-disable-line react/forbid-prop-types
};

export default CustomXAxisLabel;
